import React, { useContext, useMemo } from "react";
import "./index.scss";
import FormulaGenerator from "../../../FormulaGenerator";
import { getStepInfo } from "../../stepInfo";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const FixedProstheticsSelectToothConnections = ({
  stepId
}) => {
  const {
    language
  } = useTranslation();
  const {
    setStepFormula,
    dentalData
  } = useContext(StepContext);

  function setData(data) {
    setStepFormula(stepId, data);
  }

  const formulaHelperText = useMemo(() => {
    return getStepInfo(language, stepId)?.formulaHelperText || "";
  }, [language, stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "fixedProstheticsSelectToothConnections"
  }, /*#__PURE__*/React.createElement(FormulaGenerator, {
    projectData: dentalData,
    setProjectDentalData: setData,
    initialSelection: "fixedProstheticsSelectToothConnections",
    availableSwitchers: ["top", "bottom", "base", "fixedProstheses"],
    formulaHelperText: formulaHelperText
  }));
};

export default FixedProstheticsSelectToothConnections;